module.exports = __webpack_public_path__ + "img/143.3b97f764.jpg";